/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCurrentUserIntercomConfig
 */
export interface InternalApiCurrentUserIntercomConfig {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCurrentUserIntercomConfig
     */
    intercomEmail: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCurrentUserIntercomConfig
     */
    intercomHash: string;
}

/**
 * Check if a given object implements the InternalApiCurrentUserIntercomConfig interface.
 */
export function instanceOfInternalApiCurrentUserIntercomConfig(value: object): value is InternalApiCurrentUserIntercomConfig {
    if (!('intercomEmail' in value) || value['intercomEmail'] === undefined) return false;
    if (!('intercomHash' in value) || value['intercomHash'] === undefined) return false;
    return true;
}

export function InternalApiCurrentUserIntercomConfigFromJSON(json: any): InternalApiCurrentUserIntercomConfig {
    return InternalApiCurrentUserIntercomConfigFromJSONTyped(json, false);
}

export function InternalApiCurrentUserIntercomConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCurrentUserIntercomConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'intercomEmail': json['intercomEmail'],
        'intercomHash': json['intercomHash'],
    };
}

export function InternalApiCurrentUserIntercomConfigToJSON(json: any): InternalApiCurrentUserIntercomConfig {
    return InternalApiCurrentUserIntercomConfigToJSONTyped(json, false);
}

export function InternalApiCurrentUserIntercomConfigToJSONTyped(value?: InternalApiCurrentUserIntercomConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'intercomEmail': value['intercomEmail'],
        'intercomHash': value['intercomHash'],
    };
}

